var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "mt-4",
    staticStyle: {
      "position": "relative",
      "height": "84px",
      "padding-top": "4px"
    },
    on: {
      "dragenter": _vm.dragEnter,
      "dragleave": _vm.dragLeave,
      "dragover": _vm.dragOver,
      "drop": _vm.dragDrop
    }
  }, [_c('v-card', {
    staticClass: "mx-1 my-0 jobBlock",
    staticStyle: {
      "height": "80px",
      "user-select": "none",
      "border-style": "dashed",
      "opacity": "0.8"
    },
    attrs: {
      "outlined": ""
    }
  }, [_c('v-card-text', {
    ref: "cardText",
    staticClass: "fill-height",
    staticStyle: {
      "pointer-events": "none",
      "display": "grid",
      "place-items": "center"
    }
  }, [_c('div', {
    staticClass: "secondary--text text-caption"
  }, [_vm._v("Drag jobs here to prioritse them.")])])], 1), _c('div', {
    staticClass: "indicator",
    class: {
      'dragTop': _vm.dragover && _vm.dragPos == 'T',
      'dragBottom': _vm.dragover && _vm.dragPos == 'B'
    }
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }